module.exports = __webpack_public_path__ + "img/indextheme.ab748443.png";